<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                    :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left
                    head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(codiceStruttura)="row">
                        <span v-if="row.item.codiceStruttura">
                            {{ row.item.codiceStruttura }}
                        </span>
                        <span v-else>TUTTE</span>
                    </template>
                    <template #cell(color)="row">
                        <b-form-input disabled v-model="row.item.color" type="color"
                            style="width: 50px; height: 38px; padding: 2px; cursor: pointer; border-radius: 8px 0 0 8px;"></b-form-input>

                    </template>
                    <template #cell(icon)="row">
                        <span style="font-size: large;">{{ row.item.icon }}</span>

                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success"
                                title="Modifica Tipologia Agenda" @click="onEdit(row, $event.target)"
                                class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-danger"
                                title="Cancella Tipologia Agenda" @click="onDelete(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
            <b-modal ref="mdlTipologiaVisita" @shown="onShownEdit" hide-footer title="Crea/Modifica" @hide="onHide">
                <AgendaAppuntamentiStatiEditComponent ref="cmpAgendaTipologieVisitaEditComponent" />

                <b-row class="mt-4">
                    <b-col cols="12" class="text-right">
                        <b-button size="sm" variant="outline-secondary" class="mr-2" @click="onAnnulla"
                            :disabled="loading">
                            Annulla
                        </b-button>
                        <b-button size="sm" variant="success" :disabled="loading" @click="onSave">
                            <b-spinner small v-if="loading" class="mr-1"></b-spinner>
                            Salva
                        </b-button>
                    </b-col>
                </b-row>
            </b-modal>
        </div>
    </div>
</template>
<script>
import toast from '../../../../template/layout/utility/sa-toast.js';
import UtilityMixin from '../../../utility/UtilityMixin.js';
import AgendaAppuntamentiStatiEditComponent from "./AgendaAppuntamentiStatiEditComponent.vue"
export default {
    mixins: [UtilityMixin],
    components: { AgendaAppuntamentiStatiEditComponent },
    data() {
        return {
            filtroConfigurazioneDevice: {},
            pathResource: "/agendaappuntamentipagamentistati",
            showModalLoading: false,
            loading: false,
            filtroSessionStorage: "filtroConfigurazioneAgendaTipologieVisita",
            show: true,
            perPage: 50,
            currentPage: 1,
            allItems: [],
            rowSelected: null,
            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            struttureOptions: [],
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Nome", key: "nome", sortable: false },
                { label: "Descrizione", key: "descrizione", sortable: false },
                { label: "Colore", key: "color", sortable: false },
                { label: "Icona", key: "icon", sortable: false },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroConfigurazioneDevice = sessionStorage.getItem(this.filtroSessionStorage);
            if (filtroConfigurazioneDevice) {
                me.filtroConfigurazioneDevice = JSON.parse(filtroConfigurazioneDevice);
            }
            this.loadDataResources(me.pathResource, me.filtroConfigurazioneDevice, me.loadDataDeviceSuccess, me.loadDataDeviceError);
        },
        loadDataDeviceSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataDeviceError(error) {
            let me = this;
            console.log("Errore nel caricamento dei device:", error);
            me.$emit("afterLoadData");
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroConfigurazioneDevice = sessionStorage.getItem(this.filtroSessionStorage);
            if (filtroConfigurazioneDevice) {
                me.filtroConfigurazioneDevice = JSON.parse(filtroConfigurazioneDevice);
            }
            me.loadData(me.filtroConfigurazioneDevice);
        },
        onEdit(row) {
            this.rowSelected = row;
            this.$refs.mdlTipologiaVisita.show();
        },
        onShownEdit() {
            this.$refs.cmpAgendaTipologieVisitaEditComponent.init(this.rowSelected.item)
        },
        onDelete(item) {

            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare: " + item.nome, {
                    title: "Conferma eliminazione",
                    size: "sm",
                    okVariant: "danger",
                    okTitle: "Elimina",
                    cancelTitle: "Annulla",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteDevice(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteDevice(id) {
            let me = this;
            this.deleteResource(me.pathResource + "/" + id, me.deleteDeviceSuccess, me.deleteDeviceError);
        },
        deleteDeviceSuccess() {
            let me = this;
            toast.success("Tipo Visita Eliminato con successo!")
            me.loadData();
        },
        deleteDeviceError() {
            toast.error("errore durante l'eliminazione del tipo visita")
        },
        onAfterSaveModal() {
            let me = this;
            me.loadData();
        },
        onSave() {
            let me = this;
            this.jsonData = this.$refs.cmpAgendaTipologieVisitaEditComponent.getJsonData();
            // Validazione lato client speculare ai vincoli @NotNull di Java
            if (!me.jsonData.nome || me.jsonData.nome.trim() === "") {
                toast.error("Il Campo 'Nome' non puo' essere vuoto");
                return;
            }


            me.loading = true;

            // Esecuzione della chiamata REST tramite il mixin di sistema
            this.saveResource(
                me.pathResource,
                me.jsonData,
                me.saveSuccess,
                me.saveError
            );
        },

        /**
         * Callback REST di successo
         */
        saveSuccess() {
            let me = this;
            me.loading = false;
            toast.success("salvato con successo!");
            this.loadData();
            me.onAnnulla();
        },

        saveError(error) {
            let me = this;
            me.loading = false;
            console.error("Errore REST durante il salvataggio:", error);
            toast.error("Errore durante il salvataggio");
        },
        onHide() {
            console.log("on hide");

        },


        onAnnulla() {
            this.$refs.mdlTipologiaVisita.hide();
        }

    },
};
</script>
<style>
.sa-color-dot {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: inline-block;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
    /* Leggero bordo interno per far vedere i colori chiari/bianchi */
}
</style>
